<template>
	<div class="notice_popup prj_itv pass">
		<div class="close">
			<img class="ml-0" src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit">프로젝트 인터뷰 진행</div>
		<tec-summary tagNm="div" class="member" :value="data" />
		<div class="itv_date joinTerm">
			<span>인터뷰 예정 일/시</span>
			<span>{{intvDate | date('yyyy.MM.dd')}} / {{intvTime}}</span>
		</div>
	</div>
</template>
<script>
import tecSummary from "@/components/highpro/TecSummary.vue";

export default {
	components: { tecSummary },
	props: { param:Object },
	data() {
		return {
			data: {},
			memoCont: '',
			intvDate: '',
			intvTime: '',
		};
	},
	mounted(){
		var projectSeq = this.param.projectSeq;
		var tecMberSeq = this.param.tecMberSeq;
		var interviewReqSeq = this.param.interviewReqSeq;
		this.$.httpPost('/api/prj/adm/getPrjMberInfo', {projectSeq, tecMberSeq, interviewReqSeq})
			.then(res => {
				var hour = res.data.interviewDate.substring(8, 10);
				var amPm = 'AM';

				amPm = hour > 12 ? 'PM' : amPm;
				hour = hour > 12 ? hour - 12 : hour;

				this.intvDate = res.data.interviewDate.substring(0, 8);
				this.intvTime = amPm + ' '
							  + hour + ':'
							  + res.data.interviewDate.substring(10, 12);

				this.data = res.data;
				this.$emit('updated');
			}).catch(this.$.httpErrorCommon);
	},
};
</script>
